import { render, staticRenderFns } from "./QuestionDetailView.vue?vue&type=template&id=0222f36e&"
import script from "./QuestionDetailView.vue?vue&type=script&lang=js&"
export * from "./QuestionDetailView.vue?vue&type=script&lang=js&"
import style0 from "./QuestionDetailView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports